import { DataConsts } from "./../../../../../../models/DataConsts";
import { Garantie } from "./../../../../../../models/Garantie";
import { PortefeuilleDetail } from "./../../../../../../models/PortefeuilleDetail";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-synthese",
  templateUrl: "./synthese.component.html",
  styleUrls: ["./synthese.component.scss"],
})
export class SyntheseComponent implements OnInit {
  @Input()
  portefeuilleDetail: PortefeuilleDetail;

  @Input("garanties")
  garanties: Garantie[];

  garantieLists: Garantie[];

  constructor() {}

  ngOnInit() {
    //this.encoursTotalGaranties = this.garanties.reduce((a, b) => a + b.montantGarantie, 0);
    this.garantieLists = this.garanties.filter(function (el) {
      return el.favorability == DataConsts.FAVORABILITY;
    });
  }
}
